export default "__VITE_ASSET__8d3b238c__"